import * as React from 'react'
import styles from './styles.module.css'

export function MainContent({ children }: React.PropsWithChildren) {
  return (
    <main
      className={
        styles.mainContent
      }
      id="main-content"
      tabIndex={-1}
    >
      {children}
    </main>
  )
}
